let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("e3AwS"), load("kXcA7")]).then(() => parcelRequire('bAPy4'));